import Mensajes from '../../../../base/components/mensajes';
import AlertModal from '../../../../base/components/alertModal';
import Sedes from '../../../../salidaGraficaRed/miRedDeAtencion/sedesAtencion/src/components/sedes';
import MisProductosBeneficiarios from './components/misProductosBeneficiarios';
import Tools from '../../../../base/components/tools';

/******************** BUILD ********************/
import less from '../index.less';
/******************** BUILD ********************/

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      configurations: {},
      isAuthenticatedBoolean: false,
      isAllowed: false,
      userInfo: {}
    };
    this.plan = document.getElementById('app').getAttribute('plan');
    //CE => PC
    //EP => PBS
    this.pnpService = new ServicioPnp();

    this.tools = new Tools();
  }
      
  loadApiKey() {
    const ApiKey = this.state.configurations.ApiKey;
    if(!ApiKey) {
      setTimeout(() => this.loadApiKey(), 200);
      return;
    }
    const filename = `https://maps.googleapis.com/maps/api/js?key=${ApiKey}`;
    const file = document.createElement('script');
    file.setAttribute('type', 'text/javascript');
    file.setAttribute('src', filename);
    document.getElementsByTagName("head")[0].appendChild(file)
  }

  componentDidMount() {
    const configurations = {};
    const popovers = {};
    this.pnpService.getListWithTop('configuraciones', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote;
      });
      this.setState({ configurations: configurations }, this.loadApiKey);
    }, 200, "CSNombreText eq 'MensajeErrorDeServicios' or CSNombreText eq 'MensajeNegacionDeServicio' or CSNombreText eq 'MensajeErrorServicioBeneficiarios' or CSNombreText eq 'FBA_CLAIM' or CSNombreText eq 'ApiKey'", 'CSNombreText', 'CSValorNote');

    this.pnpService.getListWithTop('parametrosPaginas', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
      });
      this.setState({ configurations: configurations });
    }, 200, "CSNombreText eq 'MensajeErrorDeServicios' or CSNombreText eq 'MensajeNegacionUsuarioCaja' or CSNombreText eq 'MensajeNegacionDeServicio' or " + (this.plan == 'EP' ? "CSFormularioChoice eq 'PBS RA Otros Servicios'" : "CSFormularioChoice eq 'PC RA Red de Urgencias'"));
    
    setTimeout(() => { this.isAuthenticated() }, 500);
  }

  onClickAgreeButton() {
    //window.location.href = (this.plan == 'EP' ? "/salud/plan-beneficios-salud" : "/salud/plan-complementario");
    this.setState({ currentAlert: null });
    window.location.href = _spPageContextInfo.webAbsoluteUrl ;
  }

  isAuthenticated() {
    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      this.setState({ isAuthenticatedBoolean: true });
      const userInfo = compTools.obtenerInformacionUsuario();
      if(userInfo['LegalID'] && userInfo['TipoIdentificacion']){
        if(userInfo['ValidacionDerechos'] && userInfo.Error.CodigoStatusError === null){
          const validarDerechosCliente =  userInfo['ValidacionDerechos'];
          let allowed = validarDerechosCliente && validarDerechosCliente.DerechoPrestacion && validarDerechosCliente.DerechoPrestacion === 'SI' && this.plan === validarDerechosCliente.Programa ? true : false;
          userInfo.typeUser = validarDerechosCliente.Programa;
          if(allowed) {
            this.setState({ isAllowed: true, userInfo });
          }else{
            if(validarDerechosCliente && validarDerechosCliente.Programa !== 'EP' && validarDerechosCliente.Programa !== 'CE') {
              this.setState({ isAllowed: false, currentAlert: <AlertModal message={this.state.configurations['MensajeNegacionUsuarioCaja']} onClickAgreeButton={ () => this.onClickAgreeButton() } /> });
            } else if(validarDerechosCliente && validarDerechosCliente.DerechoPrestacion && validarDerechosCliente.DerechoPrestacion === 'NO'){
              this.setState({ isAllowed: false, currentAlert: <AlertModal message={this.state.configurations['MensajeNegacionDeServicio']} onClickAgreeButton={ () => this.onClickAgreeButton() } /> });
            }else if(this.plan !== validarDerechosCliente.Programa){
              this.setState({ isAllowed: false, currentAlert: <AlertModal message={this.state.configurations['MensajeNegacionDeServicio']} onClickAgreeButton={ () => this.onClickAgreeButton() } /> });
            }else {
              this.setState({ isAllowed: false, currentAlert: <Mensajes msg={this.state.configurations['MensajeErrorDeServicios']} /> });
            }
          }
        }else {
          this.setState({
            isAllowed: false,
            currentAlert: (<Mensajes msg={this.state.configurations['MensajeErrorDeServicios']} />)
          });
        };
      }else{
        this.setState({ currentAlert: <Mensajes msg={this.state.configurations['MensajeErrorDeServicios']} /> });
      }
    }
  }
  
  render() {
    let loginURL = '';
    
    if(Object.keys(this.state.configurations).length) {
      loginURL = this.tools.getLoginURL(this.state.configurations['FBA_CLAIM']);
    }
    return (
      <div>
        <div>{ this.state.currentAlert }</div>
        <div className="medical-network-info">
          <div className="row">
            <div className="col-sm-12">
              <h2 className="title">{this.state.configurations[(this.plan == 'EP' ? 'OtrosServiciosTitulo' : 'RedUrgenciasTitulo')]}</h2>
              <p dangerouslySetInnerHTML={{__html: this.state.configurations[(this.plan == 'EP' ? 'OtrosServiciosTextoIntroductorio' : 'RedUrgenciasTextoIntroductorio')]}}></p>
            </div>
          </div>
          { !this.state.isAuthenticatedBoolean ? (
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="login-box">
                    <h2>RECIBE TU INFORMACIÓN PERSONALIZADA</h2>
                    <p>Para recibir tu información personalizada es necesario que ingreses con tu usuario Compensar, asì te podremos mostrar la información personalizada para ti y de tu familia</p>
                    <div className="text-center"><a className="btn btn-primary" href={loginURL}>Iniciar Sesión</a></div>
                  </div>
                </div>
              </div>
              <Sedes configurations={this.state.configurations} plan={this.plan} />
            </div>
          ) : ((this.state.isAllowed) ? <MisProductosBeneficiarios userInfo={this.state.userInfo} plan={this.plan} configurations={this.state.configurations} /> : '')
          }
        </div>
      </div>
    );
  }
}

/******************** BUILD ********************/
const appId = document.getElementById('app');
ReactDOM.render(<App />, appId);
/******************** BUILD ********************/



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/otrosServiciosRedDeUrgencias/src/index.js